var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'floating-container',
        {
            isPC: !_vm.isH5
        }
    ]},[_c('div',{ref:"moveContainer",class:['move-container', _vm.basePoint]},[_c('free-container',{ref:"freeContainer",staticClass:"custom-free-container",attrs:{"children":_vm.tpl.children}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }